// Native / WebView friendly printing helper.
//
// Capacitor ke Android WebView (Chromium System WebView) me window.print()
// natively supported hai aur Android ka print framework (Printer / Save as PDF)
// dialog kholta hai. Iske liye kisi native plugin ki zaroorat nahi.
//
// Niche wala function di gayi HTML ko ek self-contained iframe me daalta hai,
// app ke saare stylesheets (compiled Tailwind, fonts) aur <base href> bhi inject
// karta hai taaki print bilkul screen jaisa dikhe, phir native print trigger
// karta hai. Yeh web (browser) aur Android native dono pe kaam karta hai.

const collectHeadStyles = () => {
    let head = '';
    // External stylesheets (compiled Tailwind etc.)
    document.querySelectorAll('link[rel="stylesheet"]').forEach((node) => {
        if (node.href) head += `<link rel="stylesheet" href="${node.href}">`;
    });
    // Inline <style> blocks (dev build / injected styles)
    document.querySelectorAll('style').forEach((node) => {
        head += `<style>${node.innerHTML}</style>`;
    });
    return head;
};

export default function printIonicContent(content) {
    if (!content) return;

    // Pehle se koi purana print iframe ho to hata do.
    const existing = document.getElementById('native-print-frame');
    if (existing) existing.remove();

    const iframe = document.createElement('iframe');
    iframe.id = 'native-print-frame';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.visibility = 'hidden';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    const baseHref = `${window.location.origin}/`;

    doc.open();
    doc.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<base href="${baseHref}" />
${collectHeadStyles()}
<style>
  html, body { margin: 0; padding: 0; background: #fff; }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
</style>
</head>
<body>${content}</body>
</html>`);
    doc.close();

    let hasPrinted = false;
    const triggerPrint = () => {
        if (hasPrinted) return;
        hasPrinted = true;
        try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        } catch (e) {
            // Last resort fallback.
            try { window.print(); } catch (err) { /* ignore */ }
        }
        // Print framework ko document capture karne ka time do, phir cleanup.
        setTimeout(() => {
            const f = document.getElementById('native-print-frame');
            if (f) f.remove();
        }, 60000);
    };

    // Print se pehle iframe ke images load hone ka wait karo.
    const waitForImages = () => {
        const imgs = Array.from(doc.images || []);
        const pending = imgs.filter((img) => !img.complete);
        if (pending.length === 0) {
            triggerPrint();
            return;
        }
        let done = 0;
        const onDone = () => {
            done += 1;
            if (done >= pending.length) triggerPrint();
        };
        pending.forEach((img) => {
            img.addEventListener('load', onDone);
            img.addEventListener('error', onDone);
        });
        // Agar koi image kabhi resolve na ho to safety timeout.
        setTimeout(triggerPrint, 3000);
    };

    if (doc.readyState === 'complete') {
        setTimeout(waitForImages, 50);
    } else {
        iframe.onload = () => setTimeout(waitForImages, 50);
        // WebView me kabhi onload na fire ho to fallback.
        setTimeout(waitForImages, 600);
    }
}
